import { useCurrencyStore } from "@/shared/stores";

export function parseMenuAIResponse(responseData) {
	if(!responseData) {
		return [];
	}
	if(responseData.trim().startsWith("{")) {
		return parseJsonMenu(responseData);
	}
	return parseCsvMenu(responseData);
}

function parseJsonMenu(responseData) {
	let parsed = null;
	try {
		parsed = JSON.parse(responseData);
	} catch(e) {
		return [];
	}

	let items = [];
	let categories = Array.isArray(parsed?.categories) ? parsed.categories : [];
	for(let i = 0; i < categories.length; i++) {
		let category = categories[i];
		let categoryItems = Array.isArray(category?.items) ? category.items : [];
		for(let j = 0; j < categoryItems.length; j++) {
			let item = categoryItems[j];
			items.push({
				category: (category.name || "").trim(),
				name: (item?.name || "").trim(),
				price: typeof item?.price === "number" ? Number((item.price * 100).toFixed(0)) : 0,
				description: (item?.description || "").trim(),
			});
		}
	}
	return items;
}

function parseCsvMenu(responseData) {
	let lines = responseData.split("\n");
	let items = [];
	for(let i = 0; i < lines.length; i++) {
		let fields = lines[i].split("|");
		if(fields.length === 4) {
			items.push({
				category: fields[0].trim(),
				name: fields[1].trim(),
				price: parseCsvPrice(fields[2].trim()),
				description: fields[3].trim(),
			});
		}
	}
	return items;
}

function parseCsvPrice(price) {
	const currencyStore = useCurrencyStore();
	let priceString = price.replace(",", ".").replace("€", "").replace("EUR", "").replace("eur", "").replace("$", "").replace("USD", "").replace("usd", "").trim();
	for(let currency in currencyStore.currencies) {
		let currencySymbol = currencyStore.currencies[currency].symbol;
		let currencyCode = currencyStore.currencies[currency].code;
		priceString = priceString.replace(currencySymbol, "").replace(currencyCode, "").replace(currencyCode.toLowerCase(), "").trim();
	}
	let priceFloat = parseFloat(priceString);
	if(isNaN(priceFloat)) {
		return 0;
	} else {
		return Number((priceFloat * 100).toFixed(0));
	}
}
